import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig, MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';
// eslint-disable-next-line max-len
import { SnackbarWithSpinnerComponent } from '@shared/components/notifications/snackbar-with-spinner/snackbar-with-spinner.component';
import { StringsService } from '@shared/services/strings.service';

// export enum SnackbarIconsEnum {
//   done = 'check_circle_outline',
// }

// export interface ISnackbarData {
//   icon?: SnackbarIconsEnum;
//   iconPath?: string;
// }

@Injectable({
  providedIn: 'root',
})
export class SnackbarService {
  defaultConfig: MatSnackBarConfig = {
    horizontalPosition: 'right',
    verticalPosition: 'bottom',
  };
  private currentSnackbar: MatSnackBarRef<any> | null = null;

  constructor(private snackBar: MatSnackBar, private stringsService: StringsService) {
  }

  showError(message: string, action?: string, config?: MatSnackBarConfig): MatSnackBarRef<SimpleSnackBar> {
    this.currentSnackbar = this.snackBar.open(message, action, {
      ...this.defaultConfig,
      duration: 5000,
      panelClass: [ 'mat-snackbar-error' ],
      ...config,
    });
    return this.currentSnackbar;
  }

  showMessage(message: string, action?: string, config?: MatSnackBarConfig): MatSnackBarRef<SimpleSnackBar> {
    this.currentSnackbar = this.snackBar.open(message, action, {
      ...this.defaultConfig,
      duration: 5000,
      ...config,
    });
    return this.currentSnackbar;
  }

  showMessageWithSpinner(message: string, config?: MatSnackBarConfig) {
    Promise.all([
      import('@shared/components/most-used/most-used.module'),
      import('@shared/components/notifications/snackbar-with-spinner/snackbar-with-spinner.module'),
    ]).then(([ _, cmp ]) => {
      this.currentSnackbar = this.snackBar.openFromComponent(SnackbarWithSpinnerComponent, {
        data: {
          message,
          closeBtnText: this.stringsService.strings.close,
        },
        ...this.defaultConfig,
        duration: 0,
        panelClass: 'mat-snack-bar-no-padding',
        ...config,
      });
    });
  }

  closeCurrentSnackbar() {
    if (this.currentSnackbar) {
      this.currentSnackbar.dismiss();
    }
  }
}
